import { Injectable } from '@angular/core';
import { Observable, delay, map, of } from 'rxjs';
import { ArcGisJobService } from 'app/shared/services/arcgis-job.service';
import { EsriUtils } from 'app/shared/utils/esri.utils';

interface BaseSearchPathFilterLike {
  uniqueEntity: boolean;
  maxDistance: number;
}

export interface StartAndFinalSearchPathFilterLike
  extends BaseSearchPathFilterLike {
  startPoint: __esri.Point;
  finalPoint: __esri.Point;
}

export interface LineSearchPathFilterLike extends BaseSearchPathFilterLike {
  line: __esri.Polyline;
}

export type SearchPathFilterLike =
  | StartAndFinalSearchPathFilterLike
  | LineSearchPathFilterLike;

export interface PathResponseLike {
  text: string;
  geometry: __esri.Polyline;
}

@Injectable()
export class CalcPathService {
  constructor(private arcGisJobService: ArcGisJobService) {}

  searchPaths(filter: SearchPathFilterLike): Observable<PathResponseLike[]> {
    const formData = new FormData();
    formData.append('f', 'json');
    formData.set('params', JSON.stringify(filter));
    return this.arcGisJobService
      .executeJobAndReturnResult(
        '~calcPathService',
        formData,
        'result'
      )
      .pipe(
        map(res => res.value as __esri.Graphic[]),
        map((res) => {
          if (typeof res === 'string') {
            res = JSON.parse(res);
          }

          return (
            res?.map<PathResponseLike>((x) => {
              if (typeof x === 'string') {
                x = JSON.parse(x);
              }

              const text = x.attributes.name;
              const geometry = EsriUtils.geometryFromJson(
                x.geometry
              ) as __esri.Polyline;

              return {
                text,
                geometry,
              };
            }) ?? []
          );
        })
      );
  }
}
